const indexItems = [
  { icon: 'ri-user-unfollow-line', title: '明星塌房', desc: '顶流跌落神坛全记录', count: 128 },
  { icon: 'ri-live-line', title: '网红翻车', desc: '直播带货虚假宣传合集', count: 96 },
  { icon: 'ri-tv-2-line', title: '综艺内幕', desc: '选秀节目幕后真相', count: 74 },
  { icon: 'ri-group-line', title: '饭圈乱象', desc: '粉丝经济与集资争议', count: 63 },
  { icon: 'ri-music-line', title: '选秀黑幕', desc: '内定剧本与淘汰潜规则', count: 51 },
  { icon: 'ri-smartphone-line', title: '直播争议', desc: '主播言行与平台责任', count: 89 },
  { icon: 'ri-file-list-3-line', title: '商务纠纷', desc: '艺人合约与代言风波', count: 45 },
  { icon: 'ri-heart-pulse-line', title: '情感八卦', desc: '恋情曝光与婚变传闻', count: 112 },
  { icon: 'ri-global-line', title: '跨界大瓜', desc: '跨圈联动与连环爆料', count: 38 },
];

export default function IndexSection() {
  return (
    <section id="index" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">吃瓜索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按分类快速找到你想吃的瓜</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 font-heading truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded whitespace-nowrap flex-shrink-0">
                {item.count}条
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}